import { render, staticRenderFns } from "./accordianBlock.vue?vue&type=template&id=400c1780&scoped=true&"
import script from "./accordianBlock.vue?vue&type=script&lang=js&"
export * from "./accordianBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c1780",
  null
  
)

export default component.exports